var map = {
	"./ceriani.jpeg": 14216,
	"./minutoli.jpeg": 72750,
	"./molaschi.jpg": 44697,
	"./morotti.jpeg": 15361,
	"./pegoraro.jpeg": 72118,
	"./tamburini.jpeg": 75105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75887;